<template>
    <Modal :visible="visible" @update:visible="v => $emit('update:visible', v)">
        <template v-slot:title>
            {{ __('actions.select_thing', {thing: __('general.articles')}) }}
        </template>

        <div>
            <div class="mb-10">
                <i class="fas fa-info-circle" />
                {{ __('offers.siblings_are_going_to_be_added') }}
            </div>

            <FormGroupNew :label="__('general.eans')"
                          :description="__('offers.enter_multiple_eans_per_row')"
                          required
            >
                <textarea class="form-control w-100" rows="3" v-model="eanList"/>
            </FormGroupNew>

            <button class="btn btn-primary"
                    @click="addArticles"
                    :disabled="eanList.trim().length === 0"
            >
                <i class="fas fa-plus-square"/>
                {{ __('actions.add_thing', {thing: __('general.articles')}) }}
            </button>
        </div>
    </Modal>
</template>

<script>
import Modal from "@components/Modal.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {FormGroupNew, Modal},

    emits: ['update:visible'],

    props: {
        offer: Object,
        visible: Boolean
    },

    data() {
        return {
            eanList: ''
        }
    },

    methods: {
        addArticles() {
            let eans = this.eanList.split("\n");
            this.$inertia.post(this.$route('offers.articles.update', this.offer.id), {
                action: 'add',
                eans: eans
            }, {
                onSuccess: () => {
                    this.eanList = '';
                    this.$emit('update:visible', false)
                }
            })
        }
    }
}
</script>
